import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likeGoodsService } from 'shared/src/api';
import type { GetLikedGoodsRequest } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

interface UseDeleteLikedGoodsParams {
  /**
   * 호출자(편집 화면 등)가 진입 시 사용 중인 필터.
   * 삭제 성공 시 해당 조합의 query 도 명시적으로 invalidate 하여
   * 즉시 목록이 갱신되도록 한다.
   */
  filter: Omit<GetLikedGoodsRequest, 'last_sno'>;
}

/**
 * 찜한 상품 일괄 삭제 mutation.
 * - 성공 시 prefix `['likedGoods']` 로 모든 필터 조합 cache stale 처리
 * - 추가로 호출자 진입 필터 조합의 정확한 queryKey 도 invalidate
 *   (다른 카테고리/정렬에서 캐시가 살아있어도 다음 진입 시 재요청되도록)
 */
export const useDeleteLikedGoods = ({ filter }: UseDeleteLikedGoodsParams) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: likeGoodsService.deleteLikedGoods,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKey.likedGoods(filter) });
      queryClient.invalidateQueries({ queryKey: ['likedGoods'] });
    },
  });
};
